module.exports = __webpack_public_path__ + "static/media/70.15fb829f.png";